import React from 'react';
import { NUM_PARAMS } from "../../../../config";
const style = { fontSize: '18px', fontWeight: 'bold', textAlign: 'center' };

const TotalRow = ({ data }) => {
    const td = NUM_PARAMS.map(([ param ]) => <td style={style} key={param}>{data[param]}</td>);

    return (
        <tr>
            <td colSpan={4} style={style}>Total</td>
            {td}
        </tr>
    );
};

export default TotalRow;


// WEBPACK FOOTER //
// ./src/scenes/AdKernel/components/Table/components/TotalRow/index.js